import React from 'react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';

const ErrorFallback = ({ error }) => (
    <div className="react-error">
        <h1>Something went wrong</h1>
        <p>{error.message}</p>
    </div>
);

const ErrorBoundary = ({ children }) => (
    <ReactErrorBoundary
        FallbackComponent={ErrorFallback}
    >
        {children}
    </ReactErrorBoundary>
);

export default ErrorBoundary;



// WEBPACK FOOTER //
// ./app/components/common/ErrorBoundary.jsx